import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  extractNumbers,
  getselectedIds,
  isEmptyObject,
  MakeAxiosRequest,
} from "../../../utils/handler";
import { phoneRegex } from "../../../Constants";
import { useDispatch } from "react-redux";
import FormFields from "../../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import { updateProfile } from "../../../features/authSlice";
import NewRelationship from "./../NewRelationship";
import { InfoModal } from "../../../Components/modals/InfoModal";
import Loader from "../../../Components/loader/Loader";
import UpdateInfoLayout from "./UpdateInfoLayout";

function PersonalInformation(props) {
  const {
    showModal,
    closeModal,
    editKey,
    listingFn,
    profileEdit,
    getResponse,
    updateBillingInfo,
    showMoreInfo = false,
    isMaxineStar = false,
    handleBack
  } = props;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, reset, setValue, watch, trigger, getValues, control } =
    methods;
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);

  const [prefillDetails, setPrefillDetails] = useState([]);
  const [optionsList, setOptionsList] = useState({
    relations: [],
    proxyType: [],
    additionalNeed: [],
    states: [],
    responsiblePartyList: [],
    otherRelation: [],
  });

  // const [responsiblePartyOther, setResponsiblePartyOther] = useState({});

  // const submitUrl =  profileEdit ? '/updateprofile' : (editKey ? '/updateproxy' : '/saveproxy');
  const submitUrl = profileEdit
    ? "/updateaditionalcustomerdetails"
    : "/updateaditionalrelationdetails";

  const fetchData = async () => {
    try {
      const statesList = await MakeAxiosRequest("post", "/getstates");
      const createproxyinfo = await MakeAxiosRequest(
        "post",
        "/createproxyinfo"
      );
      if (!profileEdit && editKey) {
        const edit = await MakeAxiosRequest(
          "post",
          "/getaditionalrelationdetails",
          { user_proxy_key: editKey, type: "personal_information" }
        );
        setPrefillDetails({ ...edit.data.relationDetails });
      } else if (profileEdit) {
        const profile = await MakeAxiosRequest("post", "/getaditionalcustomerdetails",{ type: "personal_information" });;
        setPrefillDetails({...profile.data.customerDetails});
      }

      const likes = createproxyinfo.data.likes?.map((item) => ({
        id: item.id,
        name: item.type,
      }));

      setOptionsList({ likes });
      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  useEffect(() => {
    setSubmitDisabled(false);
    console.log(prefillDetails);
    reset({
      grow_up: prefillDetails.grow_up || "",
      occupation: prefillDetails.occupation || "",
      veteran: prefillDetails.veteran || "",
      customer_likes: prefillDetails.likes_id || "",
      relation_likes: prefillDetails.likes_id || "",
      customer_likes_label: prefillDetails.likes_label || "",
      relation_likes_label: prefillDetails.likes_label || "",
      anything_else: prefillDetails.anything_else || "",
    });
  }, [prefillDetails]);

  const submitData = async (data) => {
    console.log(data);
    // return;
    setSubmitDisabled(true);
    if (updateBillingInfo) {
      updateBillingInfo(data);
    } else {
      try {
        data.state = data.state_id;
        data.responsible_party_phone = extractNumbers(
          data.responsible_party_phone
        );
        if(profileEdit){
          data.relation_likes = [];
        }else{
          data.customer_likes = [];
        }
        const response = await MakeAxiosRequest("post", submitUrl, {
          ...data,
          user_proxy_key: editKey,
          type: "personal_information",
        });
        // console.log(response);
        if (response.status == 1) {
          // getResponse && getResponse(response.data,(profileEdit ? 'profile' : (editKey ? 'update' : 'create')))
          reset();
          handleBack ? handleBack() : closeModal();
          listingFn && listingFn();
          // if(response.data?.msg_key =='subText'){
          //   SwalSuccess({subText: response.data?.message, showbtn:true})
          // }else{
          SwalSuccess({ msg: response.message });
          // }
          // profileEdit && dispatch(updateProfile());
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    setSubmitDisabled(false);
  };

  const fields = [
    {
      name: "grow_up",
      label: "Where have you grown up?",
      className: "col-md-6 mb-3",
      rules: {
        // required: "Please enter",
        maxLength: {
          value: 250,
          message: "Maximum 250 characters allowed"
        }
      },
      type: "inputfield",
      isShow: true,
    },
    {
      name: "occupation",
      label: "Occupation and/or Retired",
      className: "col-md-6 mb-3",
      rules: {
        // required: "Please enter",
        maxLength: {
          value: 250,
          message: "Maximum 250 characters allowed"
        }
      },
      type: "inputfield",
      isShow: true,
    },
    {
      name: "veteran",
      label: "Veteran",
      className: "col-md-6 mb-3",
      parentClassName: "d-flex",
      // rules: { required: "Please select" },
      type: "radio",
      options: [
        {
          id: "y",
          name: "Yes",
        },
        {
          id: "n",
          name: "No",
        },
      ],
      isShow: true,
    },
    {
      name: !profileEdit ? "relation_likes" : "customer_likes",
      label: "Likes",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select an option" },
      type: "popupmultiselect",
      // values:watch(!profileEdit ? "relation_likes" : "customer_likes"),
      inputlabel:!profileEdit ? "relation_likes_label" : "customer_likes_label",
      options: optionsList.likes,
      isShow: true,
    },
    {
      name: "anything_else",
      label: "Anything else?",
      className: "col-md-6 mb-3",
      rules: {
        // required: "Please enter",
        maxLength: {
          value: 250,
          message: "Maximum 250 characters allowed"
        }
      },
      type: "textarea",
      isShow: true,
    },
  ];

  if (isLoading) return <Loader />;
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitData)}>
          <UpdateInfoLayout
                      title="Personal Information"
                      handleBack={handleBack}
                      isSubmitDisabled={isSubmitDisabled}
                    >
                      <FormFields fields={fields} />
                    </UpdateInfoLayout>
          
        </form>
      </FormProvider>
     
    </>
  );
}

export default PersonalInformation;
